/**
 * Fixed drawer width (px) for the AI Sidekick panel at tablet and
 * desktop viewports.
 *
 * Consumers MUST pass this value to the paired `SidePanelLayout` so
 * the main column yields the exact right-edge the panel occupies.
 */
export const SIDEKICK_PANEL_WIDTH = 432;

/** Border radius (px) for the chat input bar wrapper. */
export const MESSAGE_INPUT_RADIUS_PX = 16;

/** Max visible rows the chat input grows to before it scrolls internally. */
export const MESSAGE_INPUT_MAX_ROWS = 6;

/** Border radius (px) used to render fully pill-shaped surfaces. */
export const PILL_RADIUS_PX = 9999;

/**
 * Width (px) of the docked entry point when expanded. Matches
 * `SIDEKICK_PANEL_WIDTH` so the card and the drawer it opens into
 * share one right-edge and the transition reads as a resize rather
 * than a jump.
 */
export const SIDEKICK_DOCK_WIDTH_PX = 432;

/** Height (px) of the expanded dock card. */
export const SIDEKICK_DOCK_EXPANDED_HEIGHT_PX = 458;

/** Height (px) of the minimized dock bar. */
export const SIDEKICK_DOCK_BAR_HEIGHT_PX = 52;

/**
 * Gap (px) between the dock and the viewport's bottom and right
 * edges.
 */
export const SIDEKICK_DOCK_EDGE_OFFSET_PX = 24;

/** Border radius (px) of the dock surface in both resting sizes. */
export const SIDEKICK_DOCK_RADIUS_PX = 24;

/**
 * Default overlay breakpoint for the drawer when it is opened from the
 * dock. A threshold above any real viewport keeps `SidePanel` on its
 * overlay branch without adding an "always overlay" flag to the shared
 * primitive, which is the only safe default: a host that mounts the
 * dock outside its router has no main column to yield width, and a
 * pushing drawer there would simply cover content.
 *
 * A host that *can* yield width overrides this via
 * `SidekickDockShellProps.overlayBelowPx`.
 */
export const SIDEKICK_DOCK_OVERLAY_ALWAYS_PX = 100_000;
